import {Inject, Injectable} from '@angular/core';
import {ConfigService} from "./config.service";
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {BasicResponse, PortalMultiFactor} from "../..";
import {Observable, throwError} from "rxjs";
import {catchError} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class MultiFactorService {

  constructor( @Inject(ConfigService) private config, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find(restUrl => restUrl.api === 'PADM').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }
  private URL;
  headers: HttpHeaders;

  private static handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }

  getMultiFactorsForPortal(portalid: number): Observable<PortalMultiFactor[]> {
    const headers = this.headers;
    return this.httpClient.get<PortalMultiFactor[]>(
        `${this.URL}/multifactor/factors/portal/${portalid}`, { headers })
        .pipe(
            catchError(MultiFactorService.handleError)
        );

  }

  getPortalMultiFactors(portalid: number): Observable<PortalMultiFactor[]> {
    const headers = this.headers;
    return this.httpClient.get<PortalMultiFactor[]>(
        `${this.URL}/multifactor/portal/${portalid}/factors/`, { headers })
        .pipe(
            catchError(MultiFactorService.handleError)
        );

  }

  AddPortalMultiFactor(portalid: number, factorid: number): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.put<BasicResponse>(
        `${this.URL}/multifactor/portal/${portalid}/factors/${factorid}`, '',{ headers })
        .pipe(
            catchError(MultiFactorService.handleError)
        );

  }

  applyPortalMultiFactor(portalid: number, portalMFA: PortalMultiFactor[]): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(
        `${this.URL}/multifactor/portal/${portalid}/factors`, portalMFA,{ headers })
        .pipe(
            catchError(MultiFactorService.handleError)
        );

  }
}
